import { identicon } from '@dicebear/collection';
import { createAvatar } from '@dicebear/core';
import Flex from 'components/common/Flex';
import PropTypes from 'prop-types';
import React from 'react';
import { Image } from 'react-bootstrap';

const TeamHeader = ({ name, description }) => {
  const logo = createAvatar(identicon, {
    seed: name,
    size: 100
  }).toDataUriSync();

  return (
    <Flex alignItems="center">
      <Image className="me-3" src={logo} alt="Logo della squadra" />
      <div className="ms-3">
        <h3 className="text-primary mb-0">{name}</h3>
        {description && <p className="mb-0">{description}</p>}
      </div>
    </Flex>
  );
};

TeamHeader.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string
};

export default TeamHeader;
